<template lang="pug">
  div
    base-snackbar(
      :errors.sync="expenseGetErrors"
    )
    v-data-table(
      :items="expenseList"
      :loading="expenseGetting"
      :headers="headers"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :server-items-length="expenseGetCount"
    )
      template(v-slot:item="{ item }")
        tr
          td {{ ((item.category || {}).description || 'N/A') }}
          td {{ item.description }}
          td {{ Number(item.cost || 0).phpFormat() }}
          td {{ (item.date || '').dateFormat() }}
          td
            base-tooltip(
              color="error"
              tooltip="delete"
              dark
              x-small
              text
              bottom
              v-if="authPermissions.has('expenses:edit')"
              @click="deleteRecord(item.id)"
              :loading="expenseDeleting"
            )
              v-icon mdi-delete

</template>
<script>
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import expenseRepository from '@/repositories/expense.repository'
import { mapState } from 'vuex'

const [expenseGetVars, expenseGetVarNames] = requestVars({ identifier: 'expense', pagination: true })
const [expenseDeleteVars, expenseDeleteVarNames] = requestVars({ identifier: 'expense', request: 'delete', hasData: false })
const expenseGetHandler = new VueRequestHandler(null, expenseGetVarNames, {}, true)
const expenseDeleteHandler = new VueRequestHandler(null, expenseDeleteVarNames)

const tableVars = () => ({
  headers: [
    { text: 'Category', value: 'expense_category_id' },
    { text: 'Description', value: 'description' },
    { text: 'Cost', value: 'cost' },
    { text: 'Date', value: 'date' },
    { text: 'Config', sortable: false },
  ],
  page: 1,
  itemsPerPage: 10,
})

export default {
  name: 'TableExpenses',
  created() {
    this.fetchExpenses()
    this.initWebsocketEvents()
  },
  beforeDestroy() {
    this.websocketEvents.forEach(eventId => {
      this.$store.dispatch('websocket/detachFromListener', [eventId])
    })
    this.websocketEvents = []
  },
  data: () => ({
    ...expenseGetVars,
    ...expenseDeleteVars,
    ...tableVars(),
    websocketEvents: [],
  }),
  watch: {
    page() {
      this.fetchExpenses()
    },
    itemsPerPage() {
      this.page = 1
      this.fetchExpenses()
    },
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    deleteRecord(id) {
      this.$confirm('are you sure you want to remove this record?')
        .then(confirm => {
          if (!confirm) return
          const handler = expenseDeleteHandler
          const repository = expenseRepository.delete
          handler.setVue(this)
          handler.execute(repository, [id])
        })
    },
    async initWebsocketEvents() {
      const dbStoreEventId = await this.$store.dispatch('websocket/attachToListener', ['DBStoreEvent', this.dbStoreEvent])
      const dbUpdateEventId = await this.$store.dispatch('websocket/attachToListener', ['DBUpdateEvent', this.dbUpdateEvent])
      this.websocketEvents.push(dbStoreEventId, dbUpdateEventId)
    },
    dbStoreEvent({ data, model }) {
      if (!model || this.$objectEmpty(data)) return
      if (model === 'Expense') {
        this.expenseDBStoreEvent()
      }
    },
    expenseDBStoreEvent() {
      this.fetchExpenses()
    },
    dbDeleteEvent({ id, model }) {
      if (!id || !model) return
      if (model === 'Expense') {
        this.expenseDBDeleteEvent(id)
      }
    },
    expenseDBDeleteEvent(id) {
      this.expenseList = this.expenseList.filter(item => item.id !== Number(id || -1))
    },
    fetchExpenses() {
      const handler = expenseGetHandler
      const repository = expenseRepository.index
      const params = this.getGetExpenseParams()
      handler.setVue(this)
      handler.execute(repository, [params])
    },
    getGetExpenseParams() {
      return {
        with: 'category',
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
        storeId: this.$store.state.settings.storeId,
      }
    },
  },
}
</script>
